import { render } from "./comps.vue?vue&type=template&id=393abf54"
import script from "./comps.vue?vue&type=script&lang=js"
export * from "./comps.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__